export default {
  state: {
    projectMembers: {
      users: [],
      teams: []
    },
    teamMembers: [],
    companyMembers: [],
    entityRoles: []
  },

  mutations: {
    setProjectMembersUsers(state, payload) {
      state.projectMembers.users = payload
    },
    setProjectMembersTeams(state, payload) {
      state.projectMembers.teams = payload
    },
    setTeamMembers(state, payload) {
      state.teamMembers = payload;
    },
    setCompanyMembers(state, payload) {
      state.companyMembers = payload;
    },
    setEntityRoles(state, payload) {
      state.entityRoles = payload;
    }
  },

  actions: {
    setProjectMembersUsers(state, payload) {
      state.commit('setProjectMembersUsers', payload);
    },
    setProjectMembersTeams(state, payload) {
      state.commit('setProjectMembersTeams', payload);
    },
    setTeamMembers(state, payload) {
      state.commit('setTeamMembers', payload);
    },
    setCompanyMembers(state, payload) {
      state.commit('setCompanyMembers', payload);
    },
    setEntityRoles(state, payload) {
      state.commit('setEntityRoles', payload);
    }
  },

  getters: {
    getProjectMembers(state) {
      return state.projectMembers;
    },
    getTeamMembers(state) {
      return state.teamMembers;
    },
    getCompanyMembers(state) {
      return state.companyMembers;
    },
    getEntityRoles(state) {
      return state.entityRoles;
    }
  }
};
